import { jsx as _jsx } from "react/jsx-runtime";
import { useDeactivateVenueFromTeam, useListTeamHomeVenues, useRemoveVenueFromTeam, } from "../api/TeamVenueApiProvider";
import { useRetrieveTeam, useRetrieveUserTeamPermissions, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { useNumericParams } from "../utils/useNumericParams";
import { ManageVenueAssociations } from "../venues/ManageVenueAssociations";
export const ManageTeamVenues = () => {
    const { id } = useNumericParams();
    const { data: permissions, isLoading: isPermsLoading, error: permsError, } = useRetrieveUserTeamPermissions({
        teamId: id,
    });
    const { canView = false, canModify = false } = permissions || {};
    const { data: team, isLoading, error, } = useRetrieveTeam({ id, enabled: canView });
    const { data: venues, isLoading: isVenuesLoading, error: venuesError, } = useListTeamHomeVenues({ teamId: id, enabled: canView });
    const deactivateMutation = useDeactivateVenueFromTeam({
        teamId: id,
        onSuccess: () => { },
        onError: () => { },
    });
    const removeMutation = useRemoveVenueFromTeam({
        teamId: id,
        onSuccess: () => { },
        onError: () => { },
    });
    const handleDeactivate = (venueAssociationId, toDate) => {
        deactivateMutation.mutate({
            teamVenueId: venueAssociationId,
            toDate,
        });
    };
    const handleRemove = (venueAssociationId) => {
        removeMutation.mutate(venueAssociationId);
    };
    if (!id) {
        return _jsx(NotFound, {});
    }
    if (isPermsLoading) {
        return _jsx(Loading, {});
    }
    if (permsError) {
        return _jsx(ErrorView, { error: permsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (isLoading || isVenuesLoading) {
        return _jsx(Loading, {});
    }
    if (error || !team || venuesError) {
        return (_jsx(ErrorView, { error: error || venuesError || new Error("Failed to load team or venues.") }));
    }
    return (_jsx(ManageVenueAssociations, { entityName: "team", entityDisplayName: team.name, entityId: id, venues: venues || [], addVenueUrl: `/teams/${id}/venues/add/`, deactivateMutation: deactivateMutation, removeMutation: removeMutation, onDeactivate: handleDeactivate, onRemove: handleRemove }));
};
